export default __webpack_public_path__ + "static/media/14.9a5eb5b5.jpg";